import { render, staticRenderFns } from "./logoSight.vue?vue&type=template&id=0f2a6ce6&scoped=true&"
import script from "./logoSight.vue?vue&type=script&lang=js&"
export * from "./logoSight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2a6ce6",
  null
  
)

export default component.exports